import styled from "styled-components";

export const PodcastsList = styled.ul`
  margin-top: 16px;

  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 80.33px;

  @media (max-width: 800px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 1360px) {
    gap: 20px;
  }
`;

export const PodcastSkeleton = styled.span`
  min-height: 152px;
  max-height: 420px;
  aspect-ratio: 1/1.35;
`;
